import { Record } from 'immutable';

export default Record({
  latitude: null,
  longitude: null,
});
